import { gql } from "urql";
export const GetWebsiteLeadCountQuery = gql `
    query GetWebsiteLeadCount(
        $archived: Boolean!
        $search: String
        $therapyCategoryIds: [String]
    ) {
        websiteLeads {
            websiteLeadCount(
                archived: $archived
                search: $search
                therapyCategoryIds: $therapyCategoryIds
            )
        }
    }
`;
export const GetWebsiteLeadsQuery = gql `
    query GetWebsiteLeads(
        $archived: Boolean!
        $search: String
        $offset: Int
        $therapyCategoryIds: [String]
    ) {
        websiteLeads {
            websiteLeads(
                archived: $archived
                search: $search
                offset: $offset
                therapyCategoryIds: $therapyCategoryIds
            ) {
                websiteLeadId
                caregiverId
                patientId
                caregiver {
                    userId
                    firstName
                    lastName
                    email
                    phoneNumber
                }
                patient {
                    patientId
                    firstName
                    lastName
                    dateOfBirth
                    postalCode
                    postalCodeInfo {
                        city
                        stateId
                        postalCode
                    }
                }
                therapyCategory {
                    therapyCategoryId
                    name
                }
                createdAt
                archivedAt
                movedToPipeline
            }
        }
    }
`;
